export default "__VITE_ASSET__CDaR0k0A__"